import { render, staticRenderFns } from "./VaccineReminderNewPopup.vue?vue&type=template&id=0383ace2&scoped=true&"
import script from "./VaccineReminderNewPopup.vue?vue&type=script&lang=js&"
export * from "./VaccineReminderNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./VaccineReminderNewPopup.vue?vue&type=style&index=0&id=0383ace2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383ace2",
  null
  
)

export default component.exports